import React from 'react';
import { Box, Button, Chip, Typography } from '@mui/material';
import { APP_CONFIG } from '@config/app.config';
import { Icon, IconSize } from '@shared/icons';

const colors = APP_CONFIG.ui.theme.colors;

interface UpgradeRequiredStateProps {
  onUpgrade: () => void;
}

const UpgradeRequiredState: React.FC<UpgradeRequiredStateProps> = ({ onUpgrade }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        boxSizing: 'border-box',
        width: '100%',
        flex: 1,
        minHeight: 380,
        px: 4,
        py: 8,
        background: `linear-gradient(180deg, ${colors.primaryTint} 0%, ${colors.background} 48%)`,
      }}
    >
      <Box
        sx={{
          width: 64,
          height: 64,
          borderRadius: '50%',
          mb: 2.5,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: colors.background,
          border: `1px solid ${colors.border}`,
          boxShadow: '0 10px 24px rgba(2, 6, 110, 0.06)',
        }}
      >
        <Icon icon="Lock01" size={IconSize.LARGE} color={colors.primary} />
      </Box>

      <Chip
        label="Plan required"
        size="small"
        sx={{
          mb: 2,
          height: 24,
          fontWeight: 600,
          bgcolor: colors.background,
          color: colors.primary,
          border: `1px solid ${colors.border}`,
          '& .MuiChip-label': {
            px: 1.25,
          },
        }}
      />

      <Typography
        variant="h6"
        sx={{
          color: colors.primaryText,
          mb: 1,
        }}
      >
        Upgrade to unlock this feature
      </Typography>

      <Typography
        variant="body2"
        sx={{
          color: colors.secondaryText,
          mb: 3,
          maxWidth: 380,
          lineHeight: '22px',
        }}
      >
        You don't have access with your current subscription. Choose a plan that includes this feature to continue.
      </Typography>

      <Button
        variant="contained"
        color="primary"
        onClick={onUpgrade}
        startIcon={<Icon icon="Stars" size={IconSize.MEDIUM} color={colors.buttonContent} />}
        sx={{
          px: 2.5,
          py: 1,
          fontWeight: 600,
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        }}
      >
        Upgrade plan
      </Button>
    </Box>
  );
};

export default UpgradeRequiredState;
